export const About = () => {
  return (
    <>
      <div className="flex justify-start items-start flex-col pb-4 lg:pb-8 mb-4 lg:my-6 lg:h-auto lg:px-16 px-6">
        <p className="text-3xl font-bold mb-4 lg:mx-10 sm:mx-2 tracking-wide text-left">
          <span className="underline underline-offset-8 decoration-4 decoration-[#E30022]">
            About
          </span>{" "}
          the conference
        </p>
        <p className="text-md lg:text-lg font-normal lg:mx-10 sm:mx-2 text-left">
          Welcome to{" "}
          <strong>
            ATAC 2026 - The 2026 Conference on Applications of Technology,
            Automation, and Civil Engineering
          </strong>
          , will be held on 19–20 March 2026 at <strong>Eastern International University
          (EIU), Binh Duong Ward, Ho Chi Minh City, Vietnam</strong>. ATAC 2026 is an{" "}
          <strong>International Academic Conference</strong> designed for
          Undergraduate, Graduate, and PhD students, as well as young scientists
          from around the world. It provides a unique global platform for
          aspiring engineers and technologists to share their innovations and
          research findings. Scheduled for <strong>March 19-20, 2026,</strong>{" "}
          ATAC 2026 aims to foster collaboration, knowledge exchange, and skill
          development in the fields of Information Technology, Machines,
          Automation, and Civil Engineering. Join us as we explore the future of
          these disciplines and contribute to shaping the world of tomorrow.
        </p>

        <p className="mt-4 text-md lg:text-lg font-normal lg:mx-10 sm:mx-2 text-left">
          Accepted papers will be published in a conference proceeding with
          ISBN. In addition, top papers from ATAC 2026 will be extended for
          publication in{" "}
          <a
            className="font-bold hover:text-blue-700"
            href="https://stdj.scienceandtechnology.com.vn/index.php/stdj/index"
            target="_blank"
            rel="noopener noreferrer"
          >
            Special Issue of VNUHCM Journal of Science and Technology
            Development (ISSN 1859-0128)
          </a>{" "}
          or{" "}
          <a
            className="font-bold hover:text-blue-700"
            href="https://www.isods.org/publications/index.php/jdsai/about"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Journal of Data Science and Artificial Intelligence (JDSAI),
            ISSN 2831-4794
          </a>
          . This peer-reviewed publication focuses on Data Science, Deep
          Learning, and Machine Learning, providing a platform for global.
          <br></br>
          <p className="mt-4">
            The Microsoft CMT service was used for managing the peer-reviewing
            process for this conference. This service was provided for free by
            Microsoft and they bore all expenses, including costs for Azure
            cloud services as well as for software development and support.
          </p>
          {/* research dissemination. More details can be found{" "}
          <a
            className="font-bold hover:text-blue-700"
            href="https://atac2026.aiotlab.vn"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a> */}
        </p>
      </div>
    </>
  );
};
